var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const config = {
  local: {
    appId: "tunnus-sdk",
    appKey: "qQqL8JnRh1FH3YJ9Obde3JNvU2uGmMYY",
    loginApiUrl: "https://login.api-test.yle.fi",
    tunnusSharedUIUrl: "https://tunnus-test.yle.fi"
  },
  test: {
    appId: "tunnus-sdk",
    appKey: "qQqL8JnRh1FH3YJ9Obde3JNvU2uGmMYY",
    loginApiUrl: "https://login.api-test.yle.fi",
    tunnusSharedUIUrl: "https://tunnus-test.yle.fi"
  },
  production: {
    appId: "tunnus-sdk",
    appKey: "dtYmXC2V3DYKhJG128xa7Alv6wK56QVo",
    loginApiUrl: "https://login.api.yle.fi",
    tunnusSharedUIUrl: "https://tunnus.yle.fi"
  }
};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var fastDeepEqual;
var hasRequiredFastDeepEqual;
function requireFastDeepEqual() {
  if (hasRequiredFastDeepEqual) return fastDeepEqual;
  hasRequiredFastDeepEqual = 1;
  fastDeepEqual = function equal2(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
      if (a.constructor !== b.constructor) return false;
      var length, i, keys;
      if (Array.isArray(a)) {
        length = a.length;
        if (length != b.length) return false;
        for (i = length; i-- !== 0; )
          if (!equal2(a[i], b[i])) return false;
        return true;
      }
      if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
      if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
      keys = Object.keys(a);
      length = keys.length;
      if (length !== Object.keys(b).length) return false;
      for (i = length; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
      for (i = length; i-- !== 0; ) {
        var key = keys[i];
        if (!equal2(a[key], b[key])) return false;
      }
      return true;
    }
    return a !== a && b !== b;
  };
  return fastDeepEqual;
}
var fastDeepEqualExports = requireFastDeepEqual();
const equal = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqualExports);
const isBroadcastMessage = (msg) => {
  return typeof msg === "object" && msg !== null && "type" in msg && typeof msg.type === "string";
};
const extractBroadcastMessage = (msg) => {
  return isBroadcastMessage(msg) ? msg : null;
};
const createBroadcastChannel = (name) => {
  if (typeof BroadcastChannel === "undefined") {
    return {
      close: () => {
        return;
      },
      postMessage: () => {
        return;
      },
      onmessage: null
    };
  }
  return new BroadcastChannel(name);
};
const translations = {
  fi: {
    closeModal: "sulje dialogi",
    logIn: "kirjaudu sisään",
    register: "luo Yle-tunnus",
    showAccountPage: "omat tiedot",
    beginIdentification: "vahvista kotikuntasi",
    acceptToS: "hyväksy käyttöehdot",
    changeNick: "valitse nimimerkki"
  },
  sv: {
    closeModal: "stäng dialogen",
    logIn: "logga in",
    register: "skapa ett Yle-konto",
    showAccountPage: "mina uppgifter",
    beginIdentification: "bekräfta din hemkommun",
    acceptToS: "godkänna användarvillkor",
    changeNick: "välj ett användarnamn"
  },
  en: {
    closeModal: "close dialog",
    logIn: "log in",
    register: "create an Yle id",
    showAccountPage: "my account",
    beginIdentification: "confirm your municipality of residence",
    acceptToS: "accept terms of service",
    changeNick: "choose a screen name"
  }
};
const translate = (language, key) => {
  return translations[language][key];
};
function deepEqual(oldObj, newObj) {
  return equal(oldObj, newObj);
}
const url = (path, base, query) => {
  const url2 = new URL(path, base);
  Object.entries(query).filter((param) => Boolean(param[1])).sort().forEach(([key, value]) => url2.searchParams.set(key, value));
  return url2;
};
const toggleNoScroll = (enable) => {
  if (enable) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "unset";
  }
};
const isYleUrl = (url2) => {
  var _a;
  const parsedUrl = URL.parse(url2);
  return ((_a = parsedUrl == null ? void 0 : parsedUrl.hostname) == null ? void 0 : _a.endsWith("yle.fi")) === true;
};
const generateMessageId = () => {
  return Date.now().toString() + "-" + Math.floor(1e4 * Math.random()).toString().padStart(4, "0");
};
const closeIcon = '<svg\n  width="24"\n  height="24"\n  viewBox="0 0 24 24"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"\n    fill="var(--icon-color)"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"\n    fill="var(--icon-color)"\n  />\n</svg>\n';
const closeCommands = ["close", "close-login"];
const dialogContentId = "tunnus-sdk__content";
const iframeFocusBreakpointPx = 500;
const createIframeQuery = (iFrameConfig) => {
  return {
    context: "iframe",
    language: iFrameConfig.language,
    theme: iFrameConfig.theme,
    tracking_app_name: iFrameConfig.trackingAppName,
    initiating_app: iFrameConfig.initiatingApp,
    return_to_url: iFrameConfig.returnToUrl,
    opening_event: iFrameConfig.openingEvent
  };
};
const getIframeContainerElement = (elementId) => {
  const existingElement = elementId ? document.getElementById(elementId) : null;
  if (existingElement !== null) {
    return existingElement;
  } else {
    const element = document.createElement("div");
    element.className = "tunnus-sdk__root";
    document.body.appendChild(element);
    return element;
  }
};
const parseCommandMessage = (event) => {
  const data = JSON.parse(event.data);
  if (!data || typeof data !== "object" || !("command" in data)) {
    throw Error("Not a valid command object");
  }
  return data;
};
const openTunnusDialog = (src, config2, iframeContainerElementId) => {
  const container = getIframeContainerElement(iframeContainerElementId);
  const srcUrl = url(src, config2.tunnusSharedUIUrl, {
    ...createIframeQuery(config2),
    for_origin: window.location.origin
  });
  const dialog = new TunnusDialog({
    iframeSrc: srcUrl.toString(),
    config: config2,
    onClose: () => {
      dialog.unmount();
      config2.onClose(config2.name);
    },
    onCommand: (data) => {
      if (closeCommands.includes(data.command)) {
        dialog.unmount();
        config2.onClose(config2.name);
      } else if (data.command === "close-and-open-url") {
        dialog.unmount();
        window.location.assign(data.args);
      }
      console.log(data, "Command from iFrame");
    }
  });
  dialog.mount(container);
  return dialog;
};
class TunnusDialog {
  constructor({ iframeSrc, config: config2, onClose, onCommand }) {
    __publicField(this, "dialog");
    __publicField(this, "dialogContainer");
    __publicField(this, "previouslyFocused", null);
    __publicField(this, "dialogId");
    __publicField(this, "onMessage");
    __publicField(this, "onClose");
    __publicField(this, "name");
    const { theme, language, name, tunnusSharedUIUrl } = config2;
    this.dialogId = crypto.randomUUID();
    this.name = name;
    this.onClose = onClose;
    toggleNoScroll(true);
    this.dialogContainer = document.createElement("div");
    this.dialogContainer.className = "tunnus-sdk__container";
    this.dialog = document.createElement("dialog");
    this.dialog.className = theme === "dark" ? "tunnus-sdk__dialog tunnus-sdk__dark" : "tunnus-sdk__dialog";
    this.dialog.setAttribute("role", "dialog");
    this.dialog.setAttribute("aria-label", translate(language, name));
    this.dialog.setAttribute("data-testid", "tunnus-sdk-dialog");
    const header = document.createElement("header");
    header.className = "tunnus-sdk__header";
    const closeButton = document.createElement("button");
    closeButton.setAttribute("aria-label", translate(language, "closeModal"));
    closeButton.onclick = onClose;
    closeButton.className = "tunnus-sdk__header__close-button";
    closeButton.innerHTML = closeIcon;
    const iframe = document.createElement("iframe");
    const queryChar = iframeSrc.includes("?") ? "&" : "?";
    iframe.id = dialogContentId;
    iframe.className = dialogContentId;
    iframe.src = `${iframeSrc}${queryChar}tunnus-iframe-id=${this.dialogId}`;
    iframe.style.height = `480px`;
    iframe.scrolling = "no";
    iframe.addEventListener(
      "load",
      this.onIframeLoaded(iframe, () => closeButton.focus()).bind(this)
    );
    header.appendChild(closeButton);
    this.dialog.appendChild(header);
    this.dialog.appendChild(iframe);
    this.onMessage = (ev) => {
      if ((ev.origin === tunnusSharedUIUrl || ev.origin === window.location.origin) && typeof ev.data === "string") {
        const messageData = parseCommandMessage(ev);
        if (messageData.iFrameId && messageData.iFrameId !== this.dialogId)
          return;
        if (messageData.command === "set-height") {
          iframe.style.height = `${messageData.args}px`;
        } else {
          onCommand(messageData);
        }
      }
    };
  }
  onIframeLoaded(iframe, focusFallback) {
    return () => {
      if (this.dialog.open) {
        if (window.innerWidth > iframeFocusBreakpointPx) {
          iframe.focus();
        } else {
          focusFallback();
        }
      }
    };
  }
  showDialog() {
    this.previouslyFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    this.dialog.show();
  }
  closeDialog() {
    var _a;
    this.dialog.close();
    (_a = this.previouslyFocused) == null ? void 0 : _a.focus();
  }
  mount(container) {
    window.addEventListener("message", this.onMessage);
    this.dialogContainer.addEventListener("click", this.onClose);
    this.dialog.addEventListener("close", this.onClose);
    this.dialogContainer.appendChild(this.dialog);
    container.appendChild(this.dialogContainer);
    this.showDialog();
  }
  unmount() {
    window.removeEventListener("message", this.onMessage);
    this.dialogContainer.removeEventListener("click", this.onClose);
    this.dialog.removeEventListener("close", this.onClose);
    this.closeDialog();
    this.dialog.remove();
    this.dialogContainer.remove();
  }
}
const loginApiUrl = (options, path) => {
  const { loginApiUrl: loginApiUrl2, appId, appKey } = config[options.environment];
  const normalizedPath = path.charAt(0) === "/" ? path : `/${path}`;
  const queryParams = new URLSearchParams({
    app_id: appId,
    app_key: appKey,
    initiating_app: options.initiatingApp
  });
  return `${loginApiUrl2}${normalizedPath}?${queryParams.toString()}`;
};
const getLoggedInUser = (options) => {
  return fetchJson(loginApiUrl(options, "/v1/user/login"));
};
const deleteLogOut = (options) => {
  return fetchJson(loginApiUrl(options, "/v1/user/login"), {
    method: "DELETE",
    credentials: "include",
    body: null
  });
};
const getIdToken = (options) => {
  return fetchJson(loginApiUrl(options, "/v1/user/id-token"));
};
const getLoginValid = (options) => {
  return fetchJson(loginApiUrl(options, "/v1/user/login/valid"));
};
class HttpError extends Error {
  constructor({
    message,
    statusCode,
    body
  }) {
    super(message);
    __publicField(this, "statusCode");
    __publicField(this, "body");
    this.message = message;
    this.name = "HttpError";
    this.statusCode = statusCode;
    this.body = body;
  }
}
async function fetchJson(url2, options = {}) {
  const response = await fetch(url2, {
    mode: "cors",
    credentials: "include",
    ...options
  });
  if (!response.ok || response.status >= 400) {
    throw new HttpError({
      message: `Fetch ${(options == null ? void 0 : options.method) ?? "GET"} to '${response.url}' failed, status ${response.status} - '${response.statusText}'`,
      statusCode: response.status,
      body: response.body
    });
  }
  return response.json();
}
const initialUserState = {
  _tag: "unknown"
};
const staleFetchThresholdMilliseconds = 1e3 * 10;
const broadcastChannelName = "yle-tunnus";
const paths = {
  logIn: "/login",
  register: "/register",
  showAccountPage: "/my-data",
  beginIdentification: "/begin-identification",
  acceptToS: "/terms-of-service",
  changeNick: "/change-nick"
};
const userStateChangeToBroadcastMessage = (prev, next) => {
  if (["failure", "logged-out"].includes(prev._tag) && next._tag === "logged-in") {
    return {
      type: "tunnus-logged-in",
      messageId: generateMessageId(),
      user: next.user
    };
  } else if (prev._tag === "unknown" && next._tag === "logged-out") {
    return {
      type: "tunnus-logged-out",
      messageId: generateMessageId(),
      userId: null
    };
  } else if (prev._tag === "logged-in" && next._tag === "logged-out") {
    return {
      type: "tunnus-logged-out",
      messageId: generateMessageId(),
      userId: prev.user.userId
    };
  } else if (prev._tag === "logged-in" && next._tag === "failure" && next.error instanceof HttpError && next.error.statusCode === 401) {
    return {
      type: "tunnus-logged-out",
      messageId: generateMessageId(),
      userId: prev.user.userId
    };
  } else if (prev._tag === "logged-in" && next._tag === "logged-in") {
    const equal2 = deepEqual(prev.user, next.user);
    return !equal2 ? {
      type: "tunnus-user-info-changed",
      messageId: generateMessageId(),
      user: next.user
    } : null;
  }
  return null;
};
const createUserInfoError = (error) => {
  if (error instanceof HttpError || error instanceof Error) {
    return error;
  } else {
    return new Error(
      `Unknown error occurred when fetching user info: ${String(error)}`
    );
  }
};
const maybeFetchUserInfo = async (options, userState, skipCache) => {
  if (!skipCache && userState._tag === "logged-in") {
    const nowPosix = (/* @__PURE__ */ new Date()).getTime();
    const lastFetchPosix = (
      // transform missing data or failure into a stale fetch timestamp (epoch)
      userState._tag === "logged-in" ? userState.fetchedAt.getTime() : 0
    );
    const shouldFetch = nowPosix - lastFetchPosix > staleFetchThresholdMilliseconds;
    if (!shouldFetch) {
      return userState;
    }
  }
  try {
    const userInfo = await getLoggedInUser(options);
    return {
      _tag: "logged-in",
      user: userInfo,
      fetchedAt: /* @__PURE__ */ new Date()
    };
  } catch (error) {
    return {
      _tag: "failure",
      error: createUserInfoError(error)
    };
  }
};
class TunnusInternal {
  constructor(options) {
    __publicField(this, "options");
    __publicField(this, "config");
    __publicField(this, "userState");
    __publicField(this, "broadcastChannel");
    __publicField(this, "currentDialog", null);
    __publicField(this, "inactiveDialog", null);
    __publicField(this, "messageListeners", []);
    __publicField(this, "processedEvents", /* @__PURE__ */ new Set());
    __publicField(this, "getIdTokenTimestamps", (token) => {
      try {
        const base64Payload = token.split(".")[1];
        const { exp, iat } = JSON.parse(atob(base64Payload));
        return { exp, iat };
      } catch (error) {
        console.error("Failed to parse ID token: ", error);
        return null;
      }
    });
    this.options = options;
    this.config = config[options.environment];
    this.userState = initialUserState;
    this.broadcastChannel = createBroadcastChannel(broadcastChannelName);
    this.broadcastChannel.onmessage = this.onBroadcastMessage.bind(this);
    window.addEventListener("message", this.onWindowPostMessage.bind(this));
    window.addEventListener("pagehide", () => {
      if (this.broadcastChannel !== null) {
        this.broadcastChannel.onmessage = null;
        this.broadcastChannel.close();
        this.broadcastChannel = null;
      }
    });
    window.addEventListener("pageshow", () => {
      if (this.broadcastChannel === null) {
        this.broadcastChannel = createBroadcastChannel(broadcastChannelName);
        this.broadcastChannel.onmessage = this.onBroadcastMessage.bind(this);
      }
    });
    document.addEventListener(
      "visibilitychange",
      this.onVisibilityChange.bind(this)
    );
  }
  addMessageListener(fn) {
    const ls = new Set(this.messageListeners);
    ls.add(fn);
    this.messageListeners = [...ls];
  }
  removeMessageListener(fn) {
    this.messageListeners = this.messageListeners.filter((l) => l != fn);
  }
  notifyBroadcastMessageListeners(msg) {
    this.messageListeners.forEach((listener) => listener(msg));
  }
  notifyParentWindow(msg) {
    if (window.parent !== window) {
      const parentUrl = document.referrer;
      if (isYleUrl(parentUrl)) {
        window.parent.postMessage(msg, parentUrl);
      }
    }
  }
  notifyIframes(msg) {
    const iframes = document.querySelectorAll("iframe");
    const sentOrigins = /* @__PURE__ */ new Set();
    iframes.forEach((iframe) => {
      var _a, _b;
      if (!isYleUrl(iframe.src)) {
        return;
      }
      const iframeOrigin = (_a = URL.parse(iframe.src)) == null ? void 0 : _a.origin;
      if (!iframeOrigin || sentOrigins.has(iframeOrigin)) {
        return;
      }
      (_b = iframe.contentWindow) == null ? void 0 : _b.postMessage(msg, iframeOrigin);
      sentOrigins.add(iframeOrigin);
    });
  }
  notifyOnStateChange(msg) {
    var _a;
    this.processedEvents.add(msg.messageId);
    (_a = this.broadcastChannel) == null ? void 0 : _a.postMessage(msg);
    this.notifyBroadcastMessageListeners(msg);
    this.notifyParentWindow(msg);
    this.notifyIframes(msg);
  }
  onWindowPostMessage(event) {
    if (!isYleUrl(event.origin)) {
      return;
    }
    const msg = extractBroadcastMessage(event.data);
    if (msg === null) {
      return;
    }
    this.handleSdkMessage(msg);
  }
  onBroadcastMessage(event) {
    const message = extractBroadcastMessage(event.data);
    if (message === null || this.broadcastChannel === null) {
      return;
    }
    if (message.type === "request-state" && this.userState._tag === "logged-in") {
      const msg = {
        type: "tunnus-user-info-available",
        messageId: generateMessageId(),
        user: this.userState.user
      };
      this.notifyOnStateChange(msg);
    } else {
      this.handleSdkMessage(message);
    }
  }
  onUserStateChange(next) {
    const previous = { ...this.userState };
    const broadcastMessage = userStateChangeToBroadcastMessage(previous, next);
    this.userState = next;
    if (broadcastMessage) {
      this.notifyOnStateChange(broadcastMessage);
    }
  }
  onVisibilityChange() {
    if (document.visibilityState === "visible") {
      this.getUserInfo(true).then((userInfo) => {
        if (userInfo) {
          window.postMessage(
            JSON.stringify({ command: "close-login" }),
            window.location.origin
          );
        }
      }).catch((error) => {
        console.error("Failed to get user info: ", error);
      });
    }
  }
  async getUserInfo(skipCache) {
    const nextUserState = await maybeFetchUserInfo(
      this.options,
      this.userState,
      skipCache
    );
    if (nextUserState._tag === "logged-in" && !nextUserState.user.latestTermsOfServiceAccepted) {
      this.onUserStateChange(initialUserState);
      if (this.options.skipToSPrompt !== true) {
        this.showAcceptToS();
      }
      return Promise.reject(
        createUserInfoError(
          new Error(
            "User exists but the latest terms of service have not been accepted"
          )
        )
      );
    }
    this.onUserStateChange(nextUserState);
    switch (nextUserState._tag) {
      case "logged-in":
        return Promise.resolve(nextUserState.user);
      case "logged-out":
        return Promise.resolve(null);
      case "failure":
        if (nextUserState.error instanceof HttpError && nextUserState.error.statusCode === 401) {
          return Promise.resolve(null);
        }
        return Promise.reject(nextUserState.error);
      case "unknown":
        return Promise.resolve(null);
    }
  }
  logIn() {
    this.openDialog(paths.logIn, "logIn");
  }
  logOut() {
    deleteLogOut(this.options).then(() => this.onUserStateChange({ _tag: "logged-out" })).catch((error) => {
      console.error("Failed to log out: ", error);
    });
  }
  /**
   * Allowed returnToUrl values are listed in
   * https://github.com/Yleisradio/identification-api/blob/master/src/identification_api/properties.clj
   */
  beginIdentification(returnToUrl) {
    const dialogConfig = this.createDialogConfig(
      "beginIdentification",
      returnToUrl
    );
    this.openDialog(
      paths.beginIdentification,
      "beginIdentification",
      dialogConfig
    );
  }
  register() {
    this.openDialog(paths.register, "register");
  }
  showAccountPage() {
    this.openDialog(paths.showAccountPage, "showAccountPage");
  }
  requireNick() {
    if (this.userState._tag === "logged-in" && this.userState.user.nick) {
      return;
    }
    this.openDialog(paths.changeNick, "changeNick");
  }
  async getIdToken() {
    return getIdToken(this.options).then((res) => res.token).catch((error) => {
      console.error("Failed to get ID token: ", error);
      return null;
    });
  }
  async validateSession() {
    return getLoginValid(this.options).then((response) => response).catch((error) => {
      console.error("Failed to validate session: ", error);
      return null;
    });
  }
  showAcceptToS() {
    this.openDialog(paths.acceptToS, "acceptToS");
  }
  openDialog(path, name, config2) {
    const iframeSrc = `${this.config.tunnusSharedUIUrl}${path}`;
    const dialogConfig = config2 || this.createDialogConfig(name);
    this.inactiveDialog = this.currentDialog;
    this.currentDialog = openTunnusDialog(
      iframeSrc,
      dialogConfig,
      this.options.elementId
    );
  }
  createDialogConfig(name, returnToUrl) {
    const requestedTheme = this.options.theme || "light";
    const dialogTheme = requestedTheme === "auto" ? this.resolveAutoTheme() : requestedTheme;
    return {
      name,
      language: this.options.language ?? "fi",
      tunnusSharedUIUrl: this.config.tunnusSharedUIUrl,
      onClose: this.onCloseDialog.bind(this),
      theme: dialogTheme,
      trackingAppName: this.options.trackingAppName,
      initiatingApp: this.options.initiatingApp,
      openingEvent: this.options.openingEvent,
      returnToUrl: returnToUrl ?? this.options.returnToUrl
    };
  }
  onCloseDialog(dialogName) {
    var _a, _b;
    this.currentDialog = null;
    (_b = window == null ? void 0 : window.history) == null ? void 0 : _b.replaceState(((_a = window == null ? void 0 : window.history) == null ? void 0 : _a.state) || {}, "");
    toggleNoScroll(false);
    const refetchUserInfo = [
      "logIn",
      "beginIdentification",
      "showAccountPage",
      "acceptToS",
      "changeNick"
    ].includes(dialogName);
    const maybeRefreshUser = refetchUserInfo ? this.getUserInfo(true).catch((e) => {
      console.log(e, "User fetch failed after the log in dialog was closed");
      return null;
    }) : Promise.resolve(null);
    void maybeRefreshUser.finally(() => {
      var _a2, _b2, _c;
      const msg = {
        type: "tunnus-dialog-closed",
        messageId: generateMessageId(),
        name: dialogName
      };
      this.notifyOnStateChange(msg);
      if (dialogName === "acceptToS" && (this.userState._tag !== "logged-in" || ((_a2 = this.inactiveDialog) == null ? void 0 : _a2.name) === "logIn")) {
        (_b2 = this.inactiveDialog) == null ? void 0 : _b2.closeDialog();
        (_c = this.inactiveDialog) == null ? void 0 : _c.unmount();
        this.inactiveDialog = null;
      }
    });
  }
  resolveAutoTheme() {
    return matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  /**
   * Handles messages from another Tunnus SDK v2 instance.
   * SDK state is practically synced between the instances.
   */
  handleSdkMessage(message) {
    if ([
      "tunnus-logged-in",
      "tunnus-logged-out",
      "tunnus-user-info-available",
      "tunnus-user-info-changed"
    ].includes(message.type)) {
      const sdkMessage = message;
      if (this.processedEvents.has(sdkMessage.messageId)) {
        return;
      }
      this.processedEvents.add(sdkMessage.messageId);
      this.notifyOnStateChange(sdkMessage);
      switch (sdkMessage.type) {
        case "tunnus-logged-out": {
          if (this.userState._tag === "logged-in") {
            this.userState = {
              _tag: "logged-out"
            };
          }
          return;
        }
        case "tunnus-logged-in":
        case "tunnus-user-info-available":
        case "tunnus-user-info-changed": {
          this.userState = {
            _tag: "logged-in",
            user: sdkMessage.user,
            fetchedAt: /* @__PURE__ */ new Date()
          };
          return;
        }
      }
    }
  }
}
function createTunnus(options) {
  const internal = new TunnusInternal(options);
  return {
    getUserInfo: () => internal.getUserInfo(),
    logIn: () => internal.logIn(),
    logOut: () => internal.logOut(),
    beginIdentification: (returnToUrl) => internal.beginIdentification(returnToUrl),
    register: () => internal.register(),
    showAccountPage: () => internal.showAccountPage(),
    getIdToken: () => internal.getIdToken(),
    getIdTokenTimestamps: (token) => internal.getIdTokenTimestamps(token),
    validateSession: () => internal.validateSession(),
    addMessageListener: (fn) => internal.addMessageListener(fn),
    removeMessageListener: (fn) => internal.removeMessageListener(fn),
    requireNick: () => internal.requireNick()
  };
}
export {
  createTunnus as default
};
//# sourceMappingURL=index.esm.js.map
